export default {
	blueprint: [
		{
			key: ["title"],
			label: "Title",
			type: "text",
		},
		{
			key: ["text"],
			label: "Text Content",
			type: "editorhtml",
		},
	],
}
